import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { showGlobalModal } from '../ducks/layout'
import infoIcon from '../images/info.png'
import pinkPin from '../images/pin.png'
import { COLORS } from '../styles/theme'
import Amplitude from '../utils/amplitudeHelper'

const PinWrapper = styled.div`
  ${(props) => props.css}
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: center;

  &:hover {
    box-shadow: 0px 0px 30px 15px ${COLORS.accentLight};

    .pins {
      animation-name: bounce;
      animation-duration: 1s;
      animation-fill-mode: both;

      .pin-text {
        display: block;
      }
    }
  }

  .pins {
    margin-top: -55px;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    width: 70px;
    height: 70px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    animation: crescendo 1.5s alternate infinite ease-in;

    .pin-text {
      position: absolute;
      z-index: 20;
      top: 50%;
      transform: translateY(-50%);
      left: 100%;
      white-space: nowrap;
      display: none;

      h5 {
        color: white;
        text-shadow: 1px 1px 1px #000;
      }
    }
  }
`

export default function LobbyEntry({
  id,
  showEntryOverlay,
  overlayText,
  setOverlayTitle,
  pinText,
  destination,
  css,
  showHelpDesk,
  entryOpenImage,
  entryCloseImage,
}) {
  const history = useHistory()
  const dispatch = useDispatch()

  const displayProgramme = () => {
    Amplitude.clickMenu()
    dispatch(showGlobalModal('programme'))
  }

  const handleClick = () => {
    if (Array.isArray(destination)) {
      showEntryOverlay(destination)
      if (overlayText) {
        setOverlayTitle(overlayText)
      }
    } else if (typeof destination === 'string') {
      history.push(destination)
    } else if (destination === 0) {
      showHelpDesk()
    } else if (destination === 1) {
      displayProgramme()
    }
  }

  return (
    <PinWrapper css={css} info={id === 'helpdesk'} onClick={handleClick}>
      <div>
        <img
          alt="door"
          className="pins"
          src={entryCloseImage}
          onMouseOver={(e) => (e.currentTarget.src = entryOpenImage)}
          onMouseOut={(e) => (e.currentTarget.src = entryCloseImage)}
        />
        <div className="pin-text">
          <h5>{pinText}</h5>
        </div>
      </div>
    </PinWrapper>
  )
}
